import { z } from 'zod';
export const saveStudentsEvaluationSchema = z.object({
    slotId: z.number(),
    students: z.array(z
        .object({
        reservationId: z.number(),
        courseMasteryRating: z.number().min(0).max(5),
        fundamentalsMasteryRating: z.number().min(0).max(5),
        focusRating: z.number().min(0).max(5),
        disciplineRating: z.number().min(0).max(5),
        isStudentAbsent: z.boolean(),
        comment: z.string().max(1000),
        imageIds: z.array(z.string()).optional(),
    })
        .superRefine((student, ctx) => {
        if (student.isStudentAbsent)
            return;
        for (const category of [
            'courseMasteryRating',
            'fundamentalsMasteryRating',
            'focusRating',
            'disciplineRating',
        ]) {
            if (student[category] < 1) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    path: [category],
                    message: 'Attribuez une note de 1 à 5.',
                });
            }
        }
    })),
});
